import { useEffect, useState } from 'react';
import { Bookmark } from 'lucide-react';
import { postService } from '@/services/api';
import { useToast } from '@/contexts/ToastContext';
import PostCard from '@/components/feed/PostCard';
import { Skeleton } from '@/components/ui/Skeleton';

export default function BookmarksPage() {
  const { toast } = useToast();
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const { data, error } = await postService.getBookmarkedPosts();
      if (cancelled) return;
      if (error) toast('Failed to load bookmarks', error.message, 'destructive');
      setPosts(data || []);
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [toast]);

  if (loading) {
    return (
      <div className="max-w-2xl mx-auto px-4 pt-4 space-y-3">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 pt-4">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Bookmarks</h1>
        <p className="text-sm text-neutral-500 dark:text-neutral-400">Posts you saved</p>
      </div>

      {posts.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <Bookmark size={40} className="mb-4 text-neutral-300 dark:text-neutral-700" />
          <p className="font-medium text-neutral-700 dark:text-neutral-300">No bookmarks yet</p>
          <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
            Tap the bookmark icon on a post to save it here.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              onPostDeleted={() => {
                setPosts((prev) => prev.filter((p) => p.id !== post.id));
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
